import React, { FC } from 'react'
import SbEditable from 'storyblok-react'
import { ComponentProps } from '..'
import { ConstrainedImageContainer } from './styles'
import { LazyImage } from '../lazy-image'

interface ConstrainedImageProps {
  image: BlokImage
}

export const ConstrainedImage: FC<ComponentProps<ConstrainedImageProps>> = ({ blok }) => {
  const { _uid, image } = blok
  const { filename, alt, title } = image || {}

  return (
    <SbEditable content={blok} key={_uid}>
      <ConstrainedImageContainer>
        <LazyImage url={filename} alt={alt} title={title} />
      </ConstrainedImageContainer>
    </SbEditable>
  )
}

